// import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
// import { useTheme } from '@mui/material/styles';
// import Tab from '@mui/material/Tab';
// import Tabs from '@mui/material/Tabs';
// import Typography from '@mui/material/Typography';
// import React from 'react';
// import FeedbackModule from './FeedbackModule';
// import DailySession from './ToSubmit';
// import TrainingFeedback from './TrainingFeedback';

// interface TabPanelProps {
//   children?: React.ReactNode;
//   dir?: string;
//   index: number;
//   value: number;
// }

// function TabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`full-width-tabpanel-${index}`}
//       aria-labelledby={`full-width-tab-${index}`}
//       style={{ overflowX: 'hidden', maxWidth: '100%' }}
//       {...other}>
//       {value === index && (
//         <Box sx={{ py: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index: number) {
//   return {
//     id: `full-width-tab-${index}`,
//     'aria-controls': `full-width-tabpanel-${index}`
//   };
// }

// const Feedback = () => {
//   const theme = useTheme();
//   const [value, setValue] = React.useState(0);

//   const handleChange = (event: React.SyntheticEvent, newValue: number) => {
//     setValue(newValue);
//   };

//   const handleChangeIndex = (index: number) => {
//     setValue(index);
//   };

//   return (
//     <>
//       {' '}
//       <Box sx={{ bgcolor: 'background.paper' }}>
//         <AppBar position="static" sx={{ borderRadius: '5px' }}>
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             indicatorColor="secondary"
//             textColor="inherit"
//             variant="fullWidth"
//             aria-label="full width tabs example">
//             <Tab label="Session" {...a11yProps(0)} />
//             <Tab label="Module" {...a11yProps(1)} />
//             <Tab label="Training" {...a11yProps(2)} />
//           </Tabs>
//         </AppBar>
//         {/* <SwipeableViews
//           axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
//           index={value}
//           onChangeIndex={handleChangeIndex}> */}
//         <TabPanel value={value} index={0} dir={theme.direction}>
//           <DailySession />
//         </TabPanel>
//         <TabPanel value={value} index={1} dir={theme.direction}>
//           <FeedbackModule />
//         </TabPanel>

//         <TabPanel value={value} index={2} dir={theme.direction}>
//           <TrainingFeedback />
//         </TabPanel>
//         {/* </SwipeableViews> */}
//       </Box>
//     </>
//   );
// };

// export default Feedback;



import React from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import FeedbackModule from './FeedbackModule';
import DailySessionToSubmit from './ToSubmit'; // Renamed locally to avoid conflict
import TrainingFeedback from './TrainingFeedback';
import LunchFeedback from './LunchFeedback';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const Feedback = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile

          sx={{
            width: '100%',
            maxWidth: '100%',
            // Ensures smooth native scrolling on touch devices
            '& .MuiTabs-scroller': {
              overflowX: 'auto !important',
              scrollbarWidth: 'none', // Hide scrollbar for Firefox
              '&::-webkit-scrollbar': {
                display: 'none', // Hide scrollbar for Chrome/Safari
              },
            },
            // Makes scroll buttons easy to click on small screens
            '& .MuiTabs-scrollButtons': {
              width: 32,
              '&.Mui-disabled': {
                opacity: 0.3,
              },
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.85rem',
              minHeight: 48,
              minWidth: 'auto', // Allows tabs to fit better
              px: { xs: 1.5, sm: 2 }, // Reduced horizontal padding on small screens
              whiteSpace: 'nowrap',
            },
          }}
        >
          <Tab label="Session Feedback" />
          <Tab label="Module Feedback" />
          <Tab label="Overall Training" />
          <Tab label="Lunch Feedback" />

        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <DailySessionToSubmit />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <FeedbackModule />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <TrainingFeedback />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <LunchFeedback />
      </CustomTabPanel>
    </Box>
  );
};

export default Feedback;